// Hotspots
(() => {
  document
    .querySelectorAll(".article-banner [data-tippy-template]")
    .forEach((template) => {
      const hotspotSelector = template.dataset.tippyTemplate;

      tippy(`.${hotspotSelector}`, {
        theme: "light",
        content: template.innerHTML,
        interactive: true,
        allowHTML: true,
      });
    });
})();
